import axios from 'axios';
import { PencilLine } from '@phosphor-icons/react';
import React, { useState, useMemo } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label } from 'reactstrap'
import { environment } from '../../env';
import { successModalToggle, getCityAction, loaderAction, getFloorTypeAction } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';

function AddFloorType({ FloorType, button, title, data }, ...props) {
    const [modal, setModal] = useState(false);
    const [editt, setEdit] = useState(false);
    const [ID, setID] = useState(0);
    const [btndis, setBtndis] = useState(false)
    const [buildingTypeError, setBuildingTypeError] = useState()

    const toggle = () => { setModal(!modal); setEdit(!editt) }
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm();
    const name = watch("name")
    const onSubmit = async (data) => {
        if (FloorType) {
            const buildingTypefilter = FloorType.filter((data, i) => {
                return data.name.toUpperCase() == name.toUpperCase()
            })
            if (buildingTypefilter?.length > 0) {
                setBuildingTypeError("This Floor Type is already created...");
                return
            }
            else {
                setBuildingTypeError("");
            }
        }

        setBtndis(true);
        dispatch(loaderAction(true))
        const buildingTypePayload = new FormData();
        buildingTypePayload.append('name', data.name.toUpperCase())
        try {
            if (button != 'edit') {
                await axios.post(`${environment.baseUrl}floor-type/`, buildingTypePayload).then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                        dispatch(loaderAction(false));
                        getFloorType();
                        toggle();
                        reset();
                        setBtndis(false)
                    }
                    else {
                        dispatch(loaderAction(false))
                        setBtndis(false)
                        console.log(err);
                    }
                })
            } else {
                await axios.put(`${environment.baseUrl}editfloortype/${ID}`, buildingTypePayload).then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                        dispatch(loaderAction(false));
                        getFloorType();
                        toggle();
                        reset();
                        setBtndis(false)
                    }
                    else {
                        dispatch(loaderAction(false))
                        setBtndis(false)
                        console.log(err);
                    }
                })
            }
        }
        catch (err) {
            dispatch(loaderAction(false));
            setBtndis(false);
            console.log(err);
        }
    };

    const CancelButton = () => {
        toggle();
        reset();
        setBtndis(false);
        setBuildingTypeError("")
    }

    const getFloorType = () => {
        try {
            axios.get(`${environment.baseUrl}floor-type/`).then(res => {
                dispatch(getFloorTypeAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    useMemo(() => {
        if (!name) {
            setBuildingTypeError("")
        }
    }, [name])
    useMemo(() => {
        if (button == 'edit') {
            reset({ 'name': data.name })
            setID(data.id)
        }
    }, [editt])

    return (
        <>
            {button != "edit" ? (
                <Button
                    onClick={toggle}
                    className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
                >
                    <span className="fs-3 d-flex gap-3 title-font-600 px-3">
                        Add New Floor Type
                    </span>
                </Button>
            ) : (
                <button
                    onClick={toggle}
                    className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' /></button>
            )} <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="lg" centered>
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>{title}</span></ModalHeader>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Add Floor Type*
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 shadow-none text-uppercase w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='text'
                                        placeholder='Enter Floor Type...'
                                        {...register("name", { required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() } })}
                                    />
                                </div>
                                {errors.name && <ErrorComponents error={'Floor Type is required *'} />}
                                {buildingTypeError && <ErrorComponents error={buildingTypeError} />}
                                <br />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>{' '}
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons'><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Add</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default AddFloorType